import {
  useQueryMembershipListAsMember,
  useQueryMembershipListAsPublic,
} from "@gymflow/api";
import useGymflowModels from "apps/portal/src/store";
import { useContext,useMemo  } from "react";

import { AuthenticationContext } from "../../../../providers/authentication/AuthenticationContext";
import { membershipFilters, MembershipTabType } from "./constants";

export const useMembershipAvailableTabs = () => {
  const { api } = useGymflowModels();
  const { userId: id } = useContext(AuthenticationContext);
  const prepaidMembershipQueryOptions = {
    api,
    opts: {
      status: "ACTIVE",
      size: 1,
      page: 0,
      ...membershipFilters.prepaid,
    },
  } as const;
  const recurringMembershipQueryOptions = {
    api,
    opts: {
      status: "ACTIVE",
      size: 1,
      page: 0,
      ...membershipFilters.recurring,
    },
  } as const;
  const trialMembershipQueryOptions = {
    api,
    opts: {
      status: "ACTIVE",
      size: 1,
      page: 0,
      ...membershipFilters.trial,
    },
  } as const;

  const prepaidMembershipPublic = useQueryMembershipListAsPublic(
    prepaidMembershipQueryOptions,
    {
      enabled: !id,
    },
  );
  const prepaidMembershipMember = useQueryMembershipListAsMember(
    prepaidMembershipQueryOptions,
    {
      enabled: !!id,
    },
  );
  const { data: prepaidMembership } = !!id
    ? prepaidMembershipMember
    : prepaidMembershipPublic;

  const recurringMembershipPublic = useQueryMembershipListAsPublic(
    recurringMembershipQueryOptions,
    {
      enabled: !id,
    },
  );
  const recurringMembershipMember = useQueryMembershipListAsMember(
    recurringMembershipQueryOptions,
    {
      enabled: !!id,
    },
  );
  const { data: recurringMembership } = !!id
    ? recurringMembershipMember
    : recurringMembershipPublic;

  const trialMembershipPublic = useQueryMembershipListAsPublic(
    trialMembershipQueryOptions,
    {
      enabled: !id,
    },
  );
  const trialMembershipMember = useQueryMembershipListAsMember(
    trialMembershipQueryOptions,
    {
      enabled: !!id,
    },
  );
  const { data: trialMembership } = !!id
    ? trialMembershipMember
    : trialMembershipPublic;
  const tabs = useMemo(() => {
    const result = [] as MembershipTabType[];
    if (recurringMembership && recurringMembership?.content.length > 0)
      result.push("recurring");
    if (prepaidMembership && prepaidMembership?.content.length > 0)
      result.push("prepaid");
    if (trialMembership && trialMembership?.content.length > 0)
      result.push("trial");
    return result;
  }, [prepaidMembership, recurringMembership, trialMembership]);
  return tabs;
};
